export const getTotalByRegion = (id, userRegion, quantitiesForRegions) => {
  let productAmounts = quantitiesForRegions.filter(
    (quantitiesForRegion) => quantitiesForRegion.id === id
  );
  let value = 0;
  if (!userRegion) {
    let defaultQuantity = productAmounts.find(
      (quantity) => quantity.field_region.toLowerCase() === "italia"
    );
    value = defaultQuantity
      ? parseInt(`0${defaultQuantity.field_amount}`, 10)
      : 0;
  } else {
    let quantityByRegion = productAmounts.find(
      (quantity) => quantity.region_tid === userRegion.targetId.toString()
    );
    value = quantityByRegion
      ? parseInt(`0${quantityByRegion.field_amount}`, 10)
      : 0;
  }

  return value;
};



// WEBPACK FOOTER //
// ./src/utils/index.js